/* mark.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./mark.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { line } from 'd3';
import { element } from '../../../core/elements';
import { useLineData } from '../providers/data';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const lineStyles = null;
function _LinePath(_ref) {
  let {
    data = [],
    x,
    y,
    fill = 'transparent',
    fillOpacity,
    strokeOpacity = 1,
    curve,
    defined = () => true,
    stroke,
    strokeWidth,
    strokeDasharray
  } = _ref;
  const path = line().x(d => x(d)).y(d => y(d)).defined(defined);
  return /*#__PURE__*/_jsx("path", {
    d: path(data) || '',
    fill: fill,
    fillOpacity: fillOpacity,
    strokeOpacity: strokeOpacity,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray
    // without this a datum surrounded by nulls will not be visible
    // https://github.com/d3/d3-shape#line_defined
    ,
    strokeLinecap: "round",
    className: ax(["_v5641de5"])
  });
}
export const LinePath = element(_LinePath);
export const LineMarkElement = element(props => {
  const {
    stroke,
    x,
    y,
    lineGroups,
    strokeWidth
  } = props;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from(lineGroups).map(_ref2 => {
      let [key, entries] = _ref2;
      return /*#__PURE__*/_jsx(LinePath, {
        stroke: stroke(key),
        strokeWidth: strokeWidth,
        data: entries,
        x: x,
        y: y
      }, `${key}-${stroke(key)}`);
    })
  });
});
export const AddMark = element(props => {
  return /*#__PURE__*/_jsx(_Fragment, {});
});
export const PointMarks = element(_ref3 => {
  let {
    lineGroups,
    xScale,
    yScale,
    colorScale,
    xAccessor,
    yAccessor,
    hide = false
  } = _ref3;
  if (hide) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from(lineGroups).map(_ref4 => {
      let [key, entries] = _ref4;
      return entries.map(entry => {
        const cx = xScale(xAccessor(entry));
        const cy = yScale(yAccessor(entry));
        if (!isNaN(cx) && !isNaN(cy)) return /*#__PURE__*/_jsx("circle", {
          cx: cx,
          cy: cy,
          r: 4,
          fill: "var(--ds-surface, #FFFFFF)",
          stroke: colorScale(key),
          strokeWidth: 2
        }, `line-mark-point-${key}-${xAccessor(entry)}`);
      });
    })
  });
});
export function LineMarkSlot() {
  const {
    xScale,
    yScale,
    colorScale,
    xAccessor,
    yAccessor,
    lineGroups,
    data,
    height
  } = useLineData();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LineMarkElement, {
      stroke: key => colorScale(key),
      x: d => {
        var _xScale;
        return (_xScale = xScale(xAccessor(d))) !== null && _xScale !== void 0 ? _xScale : 0;
      },
      y: d => {
        var _yScale;
        return (_yScale = yScale(yAccessor(d))) !== null && _yScale !== void 0 ? _yScale : height;
      },
      lineGroups: lineGroups,
      strokeWidth: 2
    }), /*#__PURE__*/_jsx(AddMark, {
      xScale: xScale,
      yScale: yScale,
      colorScale: colorScale,
      xAccessor: xAccessor,
      yAccessor: yAccessor,
      lineGroups: lineGroups,
      data: data
    }), /*#__PURE__*/_jsx(PointMarks, {
      xScale: xScale,
      yScale: yScale,
      colorScale: colorScale,
      xAccessor: xAccessor,
      yAccessor: yAccessor,
      lineGroups: lineGroups,
      data: data
    })]
  });
}